import React from 'react';
import { createMemoryRouter, Navigate } from 'react-router-dom';

import { Article } from '../../pages/Article';
import { Categories } from '../../pages/Categories';
import { Category } from '../../pages/Category';
import { ChatbotErrorScreen, ChatbotPage } from '../../pages/Chatbot';
import { Home, HomeErrorScreen } from '../../pages/Home';
import { RequestSuccessManagerForm } from '../../pages/RequestSuccessManagerForm';
import { SolutionList } from '../../pages/SolutionList';
import { AppRoutePatterns } from '../appRoutes';
import { WidgetLayout } from '../components';
import { getInitialEntries } from '../utils';

export const createHelpWidgetRouter = (history: string[]) => {
  const initialEntries = getInitialEntries(history);
  return createMemoryRouter(
    [
      {
        path: '/',
        element: <WidgetLayout />,
        children: [
          {
            path: AppRoutePatterns.Home,
            element: <Home />,
            errorElement: <HomeErrorScreen />,
          },
          {
            path: AppRoutePatterns.Chatbot,
            element: <ChatbotPage />,
            errorElement: <ChatbotErrorScreen />,
          },
          {
            path: AppRoutePatterns.Categories,
            element: <Categories />,
          },
          {
            path: AppRoutePatterns.CategoryByUri,
            element: <Category />,
          },
          {
            path: AppRoutePatterns.CategoryById,
            element: <Category />,
          },
          {
            path: AppRoutePatterns.Search,
            element: <SolutionList />,
          },
          {
            path: AppRoutePatterns.ArticleById,
            element: <Article />,
          },
          {
            path: AppRoutePatterns.ArticleByUri,
            element: <Article />,
          },
          {
            path: AppRoutePatterns.RequestSuccessManagerForm,
            element: <RequestSuccessManagerForm />,
          },
          {
            path: '*',
            element: <Navigate to={AppRoutePatterns.Home} replace />,
          },
        ],
      },
    ],
    {
      initialEntries,
    },
  );
};
